import React from 'react'
import translate from '../../../reusable/translate'

/**
 * If meterType_fi_FI starts with meterDueDate, returns meterDueDate and the rest of the title.
 * Otherwise, returns the meter index and the original meterType_fi_FI.
 */
const getMeterTitleDetails = (meter, index) => {
    let meterNumber = index + 1;
    let meterTitle = meter.meterTitle_fi_FI || meter.meterType_fi_FI;

    const dueDatePattern = new RegExp(`^${meter.meterDueDate}:`);

    if (meter.meterDueDate && dueDatePattern.test(meter.meterType_fi_FI)) {
        const meterName = meter.meterType_fi_FI.replace(dueDatePattern, '').trim();
        meterTitle = meterName;
        meterNumber = meter.meterDueDate;
    }

    return { meterNumber, meterTitle };
};

const MeterTitle = ({ meter, index }) => {
    const { meterNumber, meterTitle} = getMeterTitleDetails(meter, index)
    return(
        <div>
            <div className="flex-row items-center">
                <b>{translate({textKey: "sit.commitment.reports.meter"})} {meterNumber}:</b>
                <p className="p margin-left-small">{meterTitle}</p>
            </div>
        </div>
    )
}

export default MeterTitle


// WEBPACK FOOTER //
// ./src/components/profile/reports/components/MeterTitle.jsx